import { Suspense } from 'react'
import { createFileRoute, Outlet, useLocation } from '@tanstack/react-router'
import { Loader2 } from 'lucide-react'
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar'
import { AppSidebar } from '@/components/app-sidebar'
import { PartnerDelegationBanner } from '@/components/partner-delegation-banner'
import { AdminModeBanner } from '@/components/AdminModeBanner'

export const Route = createFileRoute('/(protected)/workspaces')({
  component: WorkspacesLayout,
})

function WorkspacesLayout() {
  const location = useLocation()
  const isReviewTopicsRoute = location.pathname.includes('/review-topics')
  const isWorkflowExecutionRoute = location.pathname.includes('/workflows/') && location.pathname.includes('/executions/')
  //以new或者export结尾，并且路径不包括/docs/或/templates/
  const isNewRoute =
    /\/(new|export)$/.test(location.pathname) &&
    !location.pathname?.includes('/docs/') &&
    !location.pathname?.includes('/templates/')
  // Wrap everything in SidebarProvider to prevent useSidebar errors
  // but only show the actual sidebar layout for routes that need it
  return (
    <Suspense
      fallback={
        <div className='flex h-screen w-screen items-center justify-center'>
          <Loader2 className='h-4 w-4 animate-spin' />
        </div>
      }
    >
      <SidebarProvider>
        {isNewRoute || isReviewTopicsRoute || isWorkflowExecutionRoute ? (
          // For new route, review-topics route, and workflow execution, just render the outlet without sidebar layout
          <Outlet />
        ) : (
          // For other routes, render the full sidebar layout
          <>
            <AppSidebar />
            <SidebarInset className='h-screen overflow-hidden'>
              <AdminModeBanner />
              <PartnerDelegationBanner />
              <Outlet />
            </SidebarInset>
          </>
        )}
      </SidebarProvider>
    </Suspense>
  )
}
